module.exports = __webpack_public_path__ + "static/assets/2d7fc00c9946be668ee303594dfebce0.png";